const doors = {
  doors: 'Puertas',
  search_door: 'Buscar puerta',
  events: 'Eventos',
  notes: 'Notas',
  basic: 'Básico',
  advanced: 'Avanzado',
  side_b: 'Lado de salida',
  side_a: 'Lado de entrada',
  options: 'Opciones',
  schedule: 'Horario',
  timing: 'Temporización',
  user_location: 'Ubicación del usuario',
  access_mode: 'Modo de acceso',
  edit: 'Editar',
  restore_tamper_alarm: 'Restaurar alarma de manipulación',
  no_tampered_msg: 'La puerta no está manipulada.',
  lockdown_grant: 'Conceder acceso de bloqueo',
  no_lockdown_msg: 'La puerta no está bloqueada.',
  total_active_doors: 'Total de puertas activas',
  form: {
    active: 'Activo',
    type_here: 'Escriba aquí',
    controller_name: 'Nombre del controlador',
    unlock_schedule: 'Horario de desbloqueo',
    unlock_first: 'Desbloqueo en el primer acceso / primera persona en entrar',
    relock_door_open: 'Rebloquear con puerta abierta',
    relock_door_closed: 'Rebloquear con puerta cerrada',
    left_open: 'Se puede dejar abierta',
    double_swipe: 'Doble deslizamiento',
    classroom_mode_solo: 'Individual',
    access_mode_normal: 'Normal',
    access_mode_classroom_toggle: 'Aula',
    access_granted: 'Acceso permitido',
    doors_open: 'Puertas abiertas',
    unlock_time: 'Tiempo de desbloqueo (segundos)',
    extended_unlock: 'Desbloqueo extendido (segundos)',
    open_prealarm: 'Prealarma de apertura demasiado larga (segundos)',
    open_alarm: 'Alarma de apertura demasiado larga (segundos)',
    rex: 'REX',
    reader: 'Lector',
    contact_input: 'Entrada de contacto',
    lock: 'Cerrar',
    door_open: 'Y aunque la puerta esté abierta',
    interlock_side: 'Interbloqueo en este lado',
    two_man_rule: 'Acceso para 2 usuarios (acompañante)',
    active_schedule: 'Horario activo',
    active_schedule_explanation:
      'Cuando el horario activo está activo, el acceso requiere Tarjeta y código de teclado. Fuera del horario, vuelve a Tarjeta o código de teclado.',
    rex_schedule: 'Horario de REX',
    unlock_options: 'Opciones de desbloqueo',
    card_only: 'Solo tarjeta',
    keypad_only: 'Solo código de teclado',
    card_or_keypad: 'Tarjeta o código de teclado',
    card_and_keypad: 'Tarjeta y código de teclado',
    none: 'Ninguno',
  },
  table: {
    door: 'PUERTA',
    state: 'ESTADO',
    lock_status: 'ESTADO DE BLOQUEO',
    access_status: 'ESTADO DE ACCESO',
  },
  legend: {
    closed: 'Cerrado',
    pre_alarm: 'Prealarma',
    alarm: 'Alarma',
    locked: 'Bloqueado',
    unlocked: 'Desbloqueado',
    unlocked_schedule: 'Desbloqueado por horario',
    access_disabled: 'Acceso deshabilitado',
    trouble: 'Problema',
    open: 'Abierto',
    alarm_forced: 'Alarma / Forzada',
    locked_operator: 'Bloquear (Sobrescribir)',
    unlocked_operator: 'Desbloquear (Sobrescribir)',
    access_enabled: 'Acceso habilitado',
    unknown: 'Desconocido',
    door_tampered: 'En alarma de manipulación',
    tampered_lockdown: 'Manipulado / Bloqueado',
  },
};

export default doors;
